export default {
  name: 're-link',

  props: {
    to: {
      type: [String, Object],
      default: null
    },
    url: {},
    label: {},
    title: {},
    classes: {
      type: [String, Array, Object],
      default: null
    },
    noDefaultClass: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {}
  },

  computed: {
    isRoute() {
      return _.isObject(this.to)
    },
    isPath() {
      return !_.isEmpty(this.to)
    },
    isUrl() {
      return !!this.url
    },
    path() {
      return this.isPath ? this.$router.match(this.to).path : null
    },
    linkClasses() {
      const defaultClasses = []
      if (!this.noDefaultClass) {
        defaultClasses.push('btn')
        defaultClasses.push('btn-link')
      }
      defaultClasses.push(this.classes)
      return defaultClasses
    },
  },
}
